<template>
  <div class="icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      viewBox="0 0 512 512"
    >
      <title>Checkmark</title>
      <path
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="80"
        d="M416 128L192 384l-96-96"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Save",
};
</script>

<style scoped lang="scss">
.icon {
  width: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/icons/Save.vue